import axiosInstance from "utils/axiosInstance";

export const fetchCharts = async () => {
    try {
        const response = await axiosInstance.get("/api/charts");
        return response.data.data;
    } catch (error) {
        console.error('Error fetching charts:', error);
        return [];
    }
};

export const createChart = async (data) => {
    try {
        const response = await axiosInstance.post("/api/charts", data);

        return response;
    } catch (error) {
        console.error('Failed to save chart:', error);
        return false;
    }
};

export const updateChart = async (data) => {
    try {
        const response = await axiosInstance.post(`/api/charts/${data.uid}`, data);

        return response;
    } catch (error) {
        console.error('Failed to save chart:', error);
        return false;
    }
};

export const deleteChart = async (uid) => {
    try {
        await axiosInstance.delete(`/api/charts/${uid}`);

        return true;
    } catch (error) {
        console.error('Failed to delete chart:', error);

        return false;
    }
};
